import { FilmIcon, FlaskIcon } from '../../../../../assets/createMenu';

/** @enum {8|[13,14,15,16]} */
export const TemplateItemType = {
    /** @type {8} */
    LIVE_DISCUSSIONS: 8,
    /** @type {[13,14,15,16]} */
    MAXDIFF: [13, 14, 15, 16],
    /** @type {17} */
    AD_REVIEW: 17,
    /** @type {18} */
    PACT_AUDIT: 18,
};

export const CATEGORY_ICONS = {
    1: 'ti-icon-new-prod-development',
    2: 'ti-icon-brandengage',
    3: 'ti-icon-comms',
    4: 'ti-icon-targetaudience',
    5: 'ti-icon-behavdata',
    7: 'ti-icon-brandengage',
    8: 'ti-icon-live-discussion',
    9: 'ti-icon-behavdata',
    ...TemplateItemType.MAXDIFF.reduce((acc: any, item) => {
        acc[item] = 'ti-icon-maxdiff';
        return acc;
    }, {}),
};

export const createItemIds = [2, 3, 4, 5, 6, 8];

export const createItemEnums = {
    LIVE_DISCUSSIONS: 8,
};

export const categoriesIcons = {
    1: FlaskIcon,
    2: FilmIcon,
};
